export default (theme) => {
  const {
    white,
    lightGrey,
    red,
    palePink,
    darkGrey,
  } = theme.palette.common
  const { maxContentWidth } = theme.global

  return {
    /* Primary footer */

    primaryContainer: {
      backgroundColor: palePink,
      padding: theme.spacing(2, 4),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(6),
      },
    },

    primaryContent: {
      maxWidth: maxContentWidth,
      margin: theme.spacing(0, 'auto'),
      padding: theme.spacing(6, 14),
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(3, 6),
        flexDirection: 'column',
      },
    },

    navigationContainer: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('md')]: {
        '& img': {
          marginBottom: theme.spacing(1),
        },
      },
    },

    menuContainer: {
      marginTop: theme.spacing(2),
    },

    subMenuContainer: {
      margin: 0,
      paddingLeft: theme.spacing(3),
    },

    link: {
      color: darkGrey,
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    noUnderline: {
      '&:hover': {
        textDecoration: 'none',
      },
    },

    email: {
      color: lightGrey,
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    /* Secondary footer */

    secondaryContainer: {
      backgroundColor: red,
      padding: theme.spacing(0, 4),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0, 4),
        flexDirection: 'column',
      },
    },

    secondaryContent: {
      maxWidth: maxContentWidth,
      padding: theme.spacing(4, 0),
      margin: theme.spacing(0, 'auto'),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },

    copyrightContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 3,
      color: white,
      '& a': {
        color: theme.palette.common.white,
      },
      '& p': {
        margin: theme.spacing(1, 0),
      },
      [theme.breakpoints.up('md')]: {
        '& > *': {
          '&:not(:last-child):after': {
            margin: 3,
            content: '"|"',
          },
        },
      },
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },

    socialContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: theme.palette.common.white,
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        '& p': {
          marginBottom: theme.spacing(1),
        },
        justifyContent: 'center',
      },
    },

    footerLogo: {
      margin: theme.spacing(4, 2),
    },

    columnContainerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(1, 0),
        flexDirection: 'column',
      },
    },

    columnContainer: {
      flexBasis: 'initial',
      flexGrow: 0,
      margin: theme.spacing(0, 2),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(1, 0),
      },
    },

    buttonsTitle: {
      display: 'none',
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(2, 0),
      },
    },
    button: {
      margin: theme.spacing(0, 1),
      maxWidth: theme.spacing(11),
      maxHeight: theme.spacing(3.5),
    },
    social: {
      color: white,
      display: 'inline-block',
      marginLeft: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0, 2),
      },
    },

    footerSocial: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        flexDirection: 'column',
      },
    },

    footerCopyright: {
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(4),
      },
    },

    logo: {
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(4),
    },
  }
}
